import React, { useState, useEffect } from "react";
import { CustomerViewDetailsViewAttachmentInfoProps } from "./customer-view-details-view-attachment-info.props";
import "./customer-view-details-view-attachment-info.scss";
import ListAttachMents from "./list-attachments";
import { getAttachments } from "../../../../../../api/lead";
import { AlertComponent } from "../../../../../../common/components";
import { getCustomerDetails, getCustomers } from "../../../../../../api/customer";

const CustomerViewDetailsViewAttachmentInfo: React.FC<
  CustomerViewDetailsViewAttachmentInfoProps
> = ({ setLoading, customerId, disableEdit, permissions }) => {
  const [selectedOption, setSelectedOption] = useState("");
  const [attachmentsList, setAttachmentsList] = useState([]);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertType, setAlertType] = useState<"success" | "error">("success");

  const handleOptionChange = (e: any) => {
    setSelectedOption(e.target.value);
  };

  const fetchAttachments = async () => {
    setLoading(true);
    try {
      const response = await getCustomerDetails(customerId);
      setAttachmentsList(response?.data?.data?.attachments);
      setLoading(false);
    } catch (error: any) {
      setLoading(false);
      setAlertMessage(
        error?.response?.data?.message || "Failed to get lead attachments."
      );
      setAlertType("error");
      setAlertOpen(true);
    }
  };

  useEffect(() => {
    fetchAttachments();
  }, [customerId]);

  const handleAlertClose = () => {
    setAlertOpen(false);
  };
  return (
    <div className="customer-list-view-details-view-box-attachment-info">
      <div className="customer-list-view-details-view-box-attachment-info-header">
        <div className="customer-list-view-details-view-box-attachment-info-header-text">
          Attachments
        </div>
      </div>
      {attachmentsList?.length > 0 ? (
        <div className="customer-list-view-details-view-box-attachment-info-list">
          <ListAttachMents
            leadId={customerId}
            attachmentsList={attachmentsList}
            fetchAttachments={fetchAttachments}
            setLoading={setLoading}
            setAlertMessage={setAlertMessage}
            setAlertType={setAlertType}
            setAlertOpen={setAlertOpen}
            disableEdit={disableEdit || !permissions?.canWrite}
          />
        </div>
      ) : (
        <div className="customer-list-view-details-view-box-attachment-info-no-data">
          No Attachments
        </div>
      )}
      <AlertComponent
        message={alertMessage}
        type={alertType}
        open={alertOpen}
        onClose={handleAlertClose}
      />
    </div>
  );
};

export default CustomerViewDetailsViewAttachmentInfo;
